import React from 'react';
import "./DandOSelector.css"
import { Link } from "react-router-dom";
import TableGrid from "../../common/components/TableGrid/tableGrid";
import { dandOSelectorColumns } from '../../common/components/TableGrid/tableColumn/DandOSelectorColumns';
import InputSearch from '../../common/components/Search/InputSearch';
import "./DandOSelector.css";

const DandOSelector = (props) => {

	const columns = dandOSelectorColumns(props);

	return(
	<React.Fragment>
		<div className={"CaseSelectorTitle dandO_titleblock"}>
			<div className='dandO_title_item' id={"commission-selector-title-holder"}>
				<div className={"commission-selector-title"}>Risk Tool: Risk Exposure and Potential Severity</div>
			</div>
			<div className='dandO_title_item'>
				<div className='dandO_search_block'>
					{ props.firmSettings.risk &&
						<Link to={"/dandos/create"}>
							<button id={"commission-create-commission-button"}>Create Risk Assessment</button>
						</Link>
					}
					<InputSearch
						handleSearch={props.handleSearch}
						handleClear={props.handleClear}
					/>
				</div>
			</div>
		</div>

		<TableGrid
			columns = {columns}
			data = {props.dandos || []}
			handleSort = {props.handleSort}
			sortValue = {props.sortValue}
			sortOrder = {props.sortOrder}
		/>

	</React.Fragment>
)};


export default DandOSelector;


// WEBPACK FOOTER //
// ./src/dandos/components/DandOSelector.js